<template>
  <div class="secret">
    <div class="banner">
      <img src="@/assets/sf-logo.png" alt />
    </div>
    <div class="form-area">
      <div>
        <h3 class="pd120">修改密码</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="secretConfFormRef"
          class="myform"
        >
          <el-form-item prop="oldpass">
            <el-input
              v-model="form.oldpass"
              placeholder="请输入原密码"
              :type="type1"
              maxlength="20"
            >
              <i
                @click="iconClick('type1')"
                slot="suffix"
                class="el-input__icon el-icon-view myicon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <psw-valid ref="pswValid" :check-value="form.pass">
              <el-input
                v-model="form.pass"
                placeholder="请设置新密码"
                :type="type2"
                maxlength="20"
                @focus="$refs.pswValid.visible = true"
                @blur="$refs.pswValid.visible = false"
              >
                <!-- @focus="passwordFocus"
                @blur="passwordFocusBlur" -->
                <i
                  @click="iconClick('type2')"
                  slot="suffix"
                  class="el-input__icon el-icon-view myicon"
                ></i>
              </el-input>
            </psw-valid>
          </el-form-item>
          <div class="des" v-show="showDes">
            <div>
              <img
                v-show="!lengthFlag"
                class="imgStyle"
                src="../../assets/passwordIconDefault.png"
                alt=""
              />
              <img
                v-show="lengthFlag"
                class="imgStyle"
                src="../../assets/passwordIcon.png"
                alt=""
              />
              <span class="textStyle">长度为8-16字符</span>
            </div>
            <div>
              <img
                v-show="!ruleFlag"
                class="imgStyle"
                src="../../assets/passwordIconDefault.png"
                alt=""
              />
              <img
                v-show="ruleFlag"
                class="imgStyle"
                src="../../assets/passwordIcon.png"
                alt=""
              />
              <span class="textStyle"
                >需同时包含大小写字母、数字、特殊符号</span
              >
            </div>
          </div>
          <el-form-item prop="checkPass">
            <el-input
              v-model="form.checkPass"
              placeholder="请重复新密码"
              :type="type3"
              maxlength="20"
            >
              <i
                @click="iconClick('type3')"
                slot="suffix"
                class="el-input__icon el-icon-view myicon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="pwdConfirm" type="danger">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import sliderCode from "@/components/sliderCode";
import pswValid from "./pswValid";
import { mapActions } from "vuex";
import _ from "lodash";
import aes from "@/utils/way";

export default {
  components: {
    sliderCode,
    pswValid
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let weakPwd = ["SF", "SHUNFENG", "ADMIN", "ROOT", "PASSWORD"];
      function checkWeekPwd(pwd) {
        for (var i = 0; i < weakPwd.length; i++) {
          if (
            weakPwd[i] == pwd.toUpperCase() ||
            pwd.toUpperCase().indexOf(weakPwd[i]) >= 0
          ) {
            return false;
          }
        }
        return true;
      }

      function checkSequence(pwd) {
        if (pwd == null) {
          return false;
        }
        var pwdUppers = pwd.toUpperCase();
        var kbs_1_1 = "1QAZ";
        var kbs_1_1_r = kbs_1_1.split("").reverse().join("");
        var kbs_1_2 = "2WSX";
        var kbs_1_2_r = kbs_1_1.split("").reverse().join("");
        var kbs_1_3 = "3EDC";
        var kbs_1_3_r = kbs_1_1.split("").reverse().join("");
        var kbs_1_4 = "4RFV";
        var kbs_1_4_r = kbs_1_1.split("").reverse().join("");
        var kbs_1_5 = "5TGB";
        var kbs_1_5_r = kbs_1_5.split("").reverse().join("");
        var kbs_1_6 = "6YHN";
        var kbs_1_6_r = kbs_1_6.split("").reverse().join("");
        var kbs_1_7 = "7UJM";
        var kbs_1_7_r = kbs_1_7.split("").reverse().join("");
        var kbs_1_8 = "8IK,";
        var kbs_1_8_r = kbs_1_8.split("").reverse().join("");
        var kbs_1_9 = "9OL.";
        var kbs_1_9_r = kbs_1_9.split("").reverse().join("");
        var kbs_1_10 = "0P;/";
        var kbs_1_10_r = kbs_1_10.split("").reverse().join("");
        var kbs_2_1 = "`1234567890-=";
        var kbs_2_1_r = kbs_2_1.split("").reverse().join("");
        var kbs_2_2 = "QWERTYUIOP[]\\";
        var kbs_2_2_r = kbs_2_2.split("").reverse().join("");
        var kbs_2_3 = "ASDFGHJKL;'";
        var kbs_2_3_r = kbs_2_3.split("").reverse().join("");
        var kbs_2_4 = "ZXCVBNM,./";
        var kbs_2_4_r = kbs_2_4.split("").reverse().join("");
        var kbs_3_1 = "~!@#$%^&*()_+";
        var kbs_3_1_r = kbs_3_1.split("").reverse().join("");
        var kbs_3_2 = "QWERTYUIOP{}|";
        var kbs_3_2_r = kbs_3_2.split("").reverse().join("");
        var kbs_3_3 = 'ASDFGHJKL:"';
        var kbs_3_3_r = kbs_3_3.split("").reverse().join("");
        var kbs_3_4 = "ZXCVBNM<>?";
        var kbs_3_4_r = kbs_3_4.split("").reverse().join("");
        // var alpha_order_1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        // var alpha_order_1_r = alpha_order_1.split('').reverse().join('')

        for (var n = 0; n < pwdUppers.length - 2; n++) {
          var s =
            pwdUppers.charAt(n) +
            pwdUppers.charAt(n + 1) +
            pwdUppers.charAt(n + 2);
          // // 3个以上英文字母顺序字符
          // if ((alpha_order_1.indexOf(s) >= 0) || (alpha_order_1_r.indexOf(s) >= 0)) {
          //     return false
          // }
          // 键盘三个连续字符的匹配(横向、大小写、shift)
          if (
            kbs_2_1.indexOf(s) >= 0 ||
            kbs_2_2.indexOf(s) >= 0 ||
            kbs_2_3.indexOf(s) >= 0 ||
            kbs_2_4.indexOf(s) >= 0 ||
            kbs_3_1.indexOf(s) >= 0 ||
            kbs_3_2.indexOf(s) >= 0 ||
            kbs_3_3.indexOf(s) >= 0 ||
            kbs_3_4.indexOf(s) >= 0 ||
            kbs_2_1_r.indexOf(s) >= 0 ||
            kbs_2_2_r.indexOf(s) >= 0 ||
            kbs_2_3_r.indexOf(s) >= 0 ||
            kbs_2_4_r.indexOf(s) >= 0 ||
            kbs_3_1_r.indexOf(s) >= 0 ||
            kbs_3_2_r.indexOf(s) >= 0 ||
            kbs_3_3_r.indexOf(s) >= 0 ||
            kbs_3_4_r.indexOf(s) >= 0
          ) {
            return false;
          }
          // 纵向三个连续
          if (
            kbs_1_1.indexOf(s) >= 0 ||
            kbs_1_2.indexOf(s) >= 0 ||
            kbs_1_3.indexOf(s) >= 0 ||
            kbs_1_4.indexOf(s) >= 0 ||
            kbs_1_1_r.indexOf(s) >= 0 ||
            kbs_1_2_r.indexOf(s) >= 0 ||
            kbs_1_3_r.indexOf(s) >= 0 ||
            kbs_1_4_r.indexOf(s) >= 0 ||
            kbs_1_5.indexOf(s) >= 0 ||
            kbs_1_6.indexOf(s) >= 0 ||
            kbs_1_7.indexOf(s) >= 0 ||
            kbs_1_8.indexOf(s) >= 0 ||
            kbs_1_5_r.indexOf(s) >= 0 ||
            kbs_1_6_r.indexOf(s) >= 0 ||
            kbs_1_7_r.indexOf(s) >= 0 ||
            kbs_1_8_r.indexOf(s) >= 0 ||
            kbs_1_9.indexOf(s) >= 0 ||
            kbs_1_10.indexOf(s) >= 0 ||
            kbs_1_9_r.indexOf(s) >= 0 ||
            kbs_1_10_r.indexOf(s) >= 0
          ) {
            return false;
          }
        }
        return true;
      }
      //控制聚焦时的框的对勾显示隐藏
      if (value.length < 8 || value.length > 16) {
        this.lengthFlag = false;
      } else {
        this.lengthFlag = true;
      }
      if (
        /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/.test(
          value
        )
      ) {
        this.ruleFlag = true;
      } else {
        this.ruleFlag = false;
      }
      this.iontop = value.length < 8 || value.length > 16;
      // 密码校验
      if (value === "") {
        callback(new Error("请输入密码！"));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error("长度为8-16位字符！"));
      } else if (
        !/^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/.test(
          value
        )
      ) {
        callback(
          new Error(
            "您的密码复杂度太低，密码中必须包含大小写字母、数字、特殊字符！"
          )
        );
      }
      // 双因素认证时产品要求修改密码去掉如下校验
      // else if (!checkSequence(value)) {
      //   callback(
      //     new Error("请不要使用三位及以上连续键盘数字或者字符作为密码！")
      //   );
      // }
      else if (value == this.form.oldpass) {
        callback(new Error("新密码不能与原密码相同！"));
      } else if (!checkWeekPwd(value)) {
        callback(
          new Error("请不要包含sf,shunfeng,admin，root，password等常见单词！")
        );
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.secretConfFormRef.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      type1: "password",
      type2: "password",
      type3: "password",
      lengthFlag: false,
      ruleFlag: false,
      flag: false,
      iontop: false,
      ionBottom: false,
      showDes: false,
      isValidated: false,
      step: 1,
      textConst: "获取验证码",
      vcodeText: "获取验证码",
      form: {
        telephone: "",
        orgName: "",
        codekey: "",
        coordinate: "",
        vCode: "",
      },
      rules: {
        oldpass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      select: "1",
      verifyPass: false,
      codekey: "",
      coordinate: "",
      accounts: "",
      phone: "",
    };
  },
  watch: {
    "form.telephone": _.debounce(function () {}, 1000),
    "form.orgName": _.debounce(function () {}, 1000),
  },
  created() {},
  methods: {
    ...mapActions([
      "login",
      "sendVerifyCodeApi",
      "checkPassOrgApi",
      "checkPassOrgMsgApi",
      "resetApi",
      "firstLandingReset",
    ]),
    iconClick(val) {
      this.flag = !this.flag;
      // this.flag ? (this.type1 = "text") : (this.type1 = "password");
      switch (val) {
        case "type1":
          this.type1 =
            this.type1 == "text"
              ? (this.type1 = "password")
              : (this.type1 = "text");
          break;
        case "type2":
          this.type2 =
            this.type2 == "text"
              ? (this.type2 = "password")
              : (this.type2 = "text");
          break;
        case "type3":
          this.type3 =
            this.type3 == "text"
              ? (this.type3 = "password")
              : (this.type3 = "text");
          break;
        default:
          break;
      }
    },
    countdown() {
      let seconds = 60;
      let tm = setInterval(() => {
        if (seconds == 0) {
          this.vcodeText = this.textConst;
          clearInterval(tm);
          return;
        }
        this.vcodeText = seconds + "S";
        seconds--;
      }, 1000);
    },
    pwdConfirm() {
      this.phone = localStorage.getItem("changeAccounts");
      this.$refs.secretConfFormRef.validate((valid) => {
        if (valid) {
          let params = {
            userId: this.$store.state.login.userId,
            telephone: this.phone,
            newPassword: aes.encrypt(this.form.pass),
            oldPassword: aes.encrypt(this.form.oldpass),
          };
          this.firstLandingReset(params)
            .then((res) => {
              if (res == 1) {
                this.$confirm("密码设置成功", "提示", {
                  confirmButtonText: "前往登录",
                  cancelButtonText: "取消",
                  showCancelButton: false,
                  type: "success",
                })
                  .then(() => {
                    setTimeout(() => {
                      this.$router.push("/");
                    }, 300);
                  })
                  .catch(() => {});
              }
            })
            .catch((err) => {
              if (err) {
                this.$message.error(err.msg);
              }
            });
        }
      });
    },
    toLogin() {
      this.$router.push("/");
    },
    passwordFocus() {
      this.showDes = true;
    },
    passwordFocusBlur() {
      this.showDes = false;
    },
  },
};
</script>
<style lang="less" scoped>
@red: #dc1e32;
@gray:rgb (61,66,70);
@black: #000;
@white: #fff;

@white45:rgba (255,255,255,.45);
@white15:rgba (255,255,255,.15);

#app .secret {
  /deep/ form {
    .tipStyle {
      background-color: rgb(232, 232, 232) !important;
      color: #333 !important;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #dcdfe6;
      outline: 0;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #fff;
    }
    .noborderight input {
      border-right: 0;
    }
    .nobordeleft > .el-input__inner {
      border-left: 0;
    }
    .is-error {
      .nobordercolor {
        .el-input__inner {
          border: 1px solid #dcdfe6;
        }
      }
      .nobordeleft {
        .el-input--suffix .el-input__inner {
          border: 0;
        }
        .el-input__inner {
          border: 1px solid #dcdfe6;
          border-left: 0;
        }
        .el-input-group__prepend {
          /* border: 1px solid #dcdfe6; */
          border-right: 0;
        }
      }
      .noborderight {
        .el-input__inner {
          border: 1px solid #dcdfe6;
          border-right: 0;
        }
        .el-input-group__append {
          border: 1px solid #dcdfe6;
          border-left: 0;
        }
      }
    }
  }
  .vcode {
    color: @red!important;
  }
  /deep/ .el-input-group__append {
    background-color: #fff;
    /* border-color: transparent; */
  }
  .success {
    text-align: center;
    padding-top: 150px;
    .succ-tip {
      font-size: 21px;
      margin-bottom: 20px;
    }
    .log-success {
      color: #67c23a;
      font-size: 48px;
    }
    .continue {
      margin-left: 50px;
    }
  }
  /deep/ .el-form-item__error {
    margin-top: 5px;
  }
  .banner {
    background: #000;
    height: 60px;
    img {
      margin-top: 10px;
      width: 120px;
    }
  }
  .form-area {
    width: 640px;
    height: 600px;
    background-color: #fff;
    box-shadow: 0 0 20px #aaa;
    margin: 50px auto;
    h3 {
      text-align: center;
      font-size: 21px;
      padding-top: 80px;
      &.pd120 {
        padding-top: 120px;
      }
    }
    form {
      .h38 {
        height: 38px;
      }
      width: 387px;
      margin: 20px auto;
      /deep/ .el-form-item__content {
        width: 100%;
        margin-bottom: 30px;
      }
      .selectPhonePrefix .el-select-dropdown__item.selected {
        color: #000;
      }
      /deep/ .el-select .el-input {
        width: 130px;
      }
      .el-button--danger {
        width: 100%;
      }
      /deep/ .myslider {
        &.slider-code.slideone {
          margin-top: 0;
        }
        .el-slider {
          padding: 0 0px;
          height: 48px;
          background-color: rgb(43, 61, 91);
          .el-slider__runway {
            background: none;
            margin: 0;
          }
          .el-slider__bar {
            display: none;
          }
          .el-slider__button-wrapper {
            width: 50px;
            height: 50px;
            top: 0;
            box-shadow: 0 0 10px #aaa;
            transform: translateX(0);
            .el-slider__button {
              width: 100%;
              height: 100%;
              background: #fff url("~@/assets/arrow.png") no-repeat center/20px;
              border-radius: 0;
              border: none;
              transform: none;
            }
          }
        }
        &.slide-success .el-slider {
          background-color: #2a76d1;
          background-image: url("../../assets/ic_btn_succeed.svg");
          background-size: 28px;
          background-repeat: no-repeat;
          background-position: right;
          .el-slider__button-wrapper {
            display: none;
          }
        }
        .slide-success .slider-text {
          color: #fff;
          background-color: rgb(43, 61, 91);
        }
      }
    }
  }
}
.des {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px !important;
  margin: -20px 0 20px 0 !important;
  background-image: url("../../assets/passwordRule.png");
  background-size: 100% 100%;
}
.myform /deep/ .el-form-item__content {
  margin-bottom: 20px !important;
}
.myicon {
  cursor: pointer;
}
.textStyle {
  font-size: 14px;
  height: 21px;
  // line-height: 21px;
  font-family: PingFangSC-Regular;
  color: #909399;
  padding-left: 6px !important;
}
.imgStyle {
  width: 14px;
  height: 14px;
  margin-bottom: -2px;
}
</style>